import type { ScheduleItem, Traveler, TravelerId } from "../types";

/** Solo stop → one traveler for the tiny caption avatar; shared → null. */
export function soloTravelerForItem(
  item: Pick<ScheduleItem, "travelers">,
  travelers: Traveler[],
): Traveler | null {
  const ids = item.travelers ?? [];
  if (ids.length !== 1) return null;
  return travelers.find((t) => t.id === ids[0]) ?? null;
}

export function soloInitial(t: Traveler): string {
  const s = (t.shortName || t.id || "?").trim();
  return (s[0] || "?").toUpperCase();
}

export function isMichael(id: TravelerId): boolean {
  return id === "michael";
}
